import checkmarkIcon from '../../assets/icons/checkmark-icon.svg';
import checkmarkIndeterminateWhite from '../../assets/icons/indeterminate-white-icon.svg';
import checkmarkIndeterminateBlack from '../../assets/icons/indeterminate-black-icon.svg';

interface Props {
  uniqueName: string;
  type: string;
  isChecked: boolean;
  setIsChecked: (isChecked: boolean) => void;
}

export const CheckboxComponent = ({ uniqueName, type, isChecked, setIsChecked }: Props) => {
  return (
    <>
      {type == '1' ? (
        <div className='checkbox-container'>
          <input
            checked={isChecked}
            type='checkbox'
            className='checkbox-input'
            id={uniqueName}
            onChange={() => {
              setIsChecked(!isChecked);
            }}
          ></input>

          <label htmlFor={uniqueName} className='checkbox-label'>
            <img className='checkbox-img' src={checkmarkIcon}></img>
            {uniqueName}
          </label>
        </div>
      ) : (
        <div className='checkbox-container'>
          <input checked={isChecked} type='checkbox' className='checkbox-input' id={uniqueName} onChange={() => setIsChecked(!isChecked)}></input>
          <label htmlFor={uniqueName} className='checkbox-label'>
            <img className='checkbox-img' src={isChecked ? checkmarkIndeterminateWhite : checkmarkIndeterminateBlack}></img>
            {uniqueName}
          </label>
        </div>
      )}
    </>
  );
};
